import * as Api from '../utils/api';
const basePath = 'companylink';

export function getCompanyLinks(data) {
    return Api.postData(`/api/${basePath}/getCompanyLinks`, data).then(response => response.json());
}

export function unlinkCompany(data) {
    return Api.postData(`/api/${basePath}/unlinkCompany`, data).then(response => response.json());
}